import { ENV_CONFIG } from 'config/environment';

export const Header = () => {
  return (
    <div className="header-container">
      <div className="header-content">
        <div className="header-content-left">
          <img
            src={`${ENV_CONFIG.CLOUD_STORAGE.URL}/scampac/header-image.png`}
            alt="Header Image"
            className="header-image"
          />
        </div>
        <div className="header-content-right">
          <span className="h1-dtm">Don't get scammed into a bad donation</span>
          <span className="h3-dtm">
            Grift Alert is the scam-sniffing, BS-detecting guide to political giving. Together, we
            spotlight the fakes and arm donors with the truth so they can actually fund change, not
            someone's lake house.
          </span>
        </div>
      </div>
    </div>
  );
};
